import { render } from "./ModalAddAddressBliing.vue?vue&type=template&id=45ec3667&scoped=true&ts=true"
import script from "./ModalAddAddressBliing.vue?vue&type=script&lang=ts"
export * from "./ModalAddAddressBliing.vue?vue&type=script&lang=ts"

import "./ModalAddAddressBliing.vue?vue&type=style&index=0&id=45ec3667&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ec3667"]])

export default __exports__